import { Component, Input } from '@angular/core';
import { DVFormGroup } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';


@Component({
  selector: 'app-add-experience-activity',
  templateUrl: './add-experience-activity.component.html',
  styleUrls: ['./add-experience-activity.component.css']
})
export class AddExperienceActivityComponent {
  @Input() index: number;
  @Input() experienceDayForm: DVFormGroup;
}
